import { Component, OnInit, EventEmitter, Output, Input, TemplateRef, ViewChild } from '@angular/core';
//import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { PHBHPFeaturePackageAuthorizationService } from "../ph-bhp-feature-package-authorization.service"
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'lib-ph-bhp-forget-password',
  templateUrl: './ph-bhp-forget-password.component.html',
  styleUrls: ['./ph-bhp-forget-password.component.css']
})
export class PhBhpForgetPasswordComponent implements OnInit {

  @Output() childData = new EventEmitter();
  @Input() isDesktop = true;
  @Input() isUserName = true;
  placeHolder = "Enter your username";
  lableName = "Username";
  formdata: any;
  inputName: string
  modalRef: BsModalRef;
  translationKeys: typeof TranslationKeys = TranslationKeys;

  public languages = [
    {
      language: this.translationKeys.Label.English,
      value: "en"
    },
    {
      language: this.translationKeys.Label.German,
      value: "de"
    },
    {
      language: this.translationKeys.Label.Hungarian,
      value: "hu"
    },
    {
      language: this.translationKeys.Label.Spanish,
      value: "es"
    },
    {
      language: this.translationKeys.Label.French,
      value: "fr"
    },
    {
      language: this.translationKeys.Label.Czeck,
      value: "cs"
    },
    {
      language: this.translationKeys.Label.Slovakian,
      value: "sk"
    },
    {
      language: this.translationKeys.Label.Dutch,
      value: "nl"
    },
    {
      language: this.translationKeys.Label.Catalan,
      value: "ca"
    }, {
      language: this.translationKeys.Label.Portuguese,
      value: "pt"
    },
  ];

  public languageSelected: string;
  public device!: 'tablet' | 'mobile' | 'desktop';

  constructor(private service: PHBHPFeaturePackageAuthorizationService, private sanitizer: DomSanitizer, private layoutService: PHBHPLayoutPackageService, private modalService: BsModalService, public translate: TranslateService) {

    this.device = 'desktop';
    const lang = localStorage.getItem('selectedLanguage');
    if (lang) {
      this.languageSelected = lang;
    } else {
      this.languageSelected = 'en';
    }
  }

  ngOnInit() {
    this.formdata = new UntypedFormGroup({
      inputName: new UntypedFormControl('', Validators.compose([
        Validators.required
      ]))
    })
    if (!this.isUserName) {
      this.placeHolder = "Enter your Email";
      this.lableName = "Email";
    }
  }

  changeSelectLang(lang: string) {
    this.languageSelected = lang;
    this.translate.use(this.languageSelected);
    localStorage.setItem('selectedlanguage', lang);
  }

  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  onSubmit(value): void {

    if (value.inputName === '') {
      return;
    }
    this.layoutService.showLoader = true;
    this.service.InitiatePasswordReset(value.inputName).subscribe((res) => {
      this.layoutService.showLoader = false;
      if (res) {
        this.childData.emit();
        this.layoutService.showSuccess(this.layoutService.translateText(this.translationKeys.SuccessMessages.PasswordSentToMail));

      } else {
        //this.childData.emit();
        this.layoutService.showError(this.layoutService.translateText(this.translationKeys.WarningMessages.UsernameNotFound));
      }
    });

  }

  cancelModal() {
    this.onBackToSignIn()
  }

  onBackToSignIn() {
    this.childData.emit('back');
  }
}
